export const linkStyle = {
  textDecoration: "inherit",
  color: "inherit",
};

export const iconStyle = {
  fontSize: "1.4rem",
  color: "var(--color-gray)",
  marginLeft: "0rem",
  position: "relative",
};
